// 보관 기간은 API 설정(order.customer-name.*, email.code.*, inquiry.retention.*)과 같아야 하고, 내용을 고치면 시행일도 바꾼다.

export const PRIVACY_POLICY_EFFECTIVE_DATE = '2026년 10월 6일';

export const PRIVACY_OFFICER = {
  name: '박지인',
  email: 'contact@kio-school.com',
} as const;

export type PrivacyPolicyBlock =
  | { type: 'paragraph'; text: string }
  | { type: 'list'; items: string[] }
  | { type: 'table'; headers: string[]; rows: string[][] };

export interface PrivacyPolicySection {
  title: string;
  blocks: PrivacyPolicyBlock[];
}

export const PRIVACY_POLICY_INTRO =
  '키오스쿨은 「개인정보 보호법」에 따라 이용자의 개인정보를 보호하고 관련 고충을 빠르게 처리하기 위해 다음과 같이 개인정보처리방침을 둡니다.';

export const PRIVACY_POLICY_SECTIONS: PrivacyPolicySection[] = [
  {
    title: '1. 개인정보의 처리 목적',
    blocks: [
      { type: 'paragraph', text: '키오스쿨은 다음 목적으로만 개인정보를 처리합니다. 목적이 바뀌면 미리 알리고, 필요하면 동의를 받습니다.' },
      {
        type: 'list',
        items: [
          '주점 운영진 회원 관리: 가입 의사 확인, 본인 확인, 로그인, 비밀번호 재설정',
          '주점 운영 기능 제공: 주문 접수, 입금 확인, 테이블 관리, 매출 통계',
          '손님 송금 안내: 주점 계좌 정보 표시, 예금주 확인',
          '문의 응대: 문의 내용 확인과 답변 발송',
          '서비스 안정성 확보: 오류 추적, 자동 등록 방지, 이용 통계 분석',
        ],
      },
    ],
  },
  {
    title: '2. 처리하는 개인정보 항목과 보유 기간',
    blocks: [
      {
        type: 'table',
        headers: ['구분', '항목', '보유 기간'],
        rows: [
          ['주점 운영진 회원 (필수)', '아이디, 비밀번호(암호화하여 저장), 이름, 이메일', '회원 탈퇴 시까지'],
          ['이메일 인증', '이메일, 인증 코드', '마지막 발송 후 7일'],
          ['계좌 등록 (선택)', '은행, 계좌번호, 예금주명, 토스 송금 링크', '계좌 삭제 또는 회원 탈퇴 시까지'],
          ['가입 경로 설문 (선택)', '키오스쿨을 알게 된 경로, 응답 내용', '회원 탈퇴 시까지'],
          ['손님 주문', '입금자명, 테이블 번호, 주문 내역', '입금자명은 주문 후 90일이 지나면 가립니다. 주문 내역은 주점 매출 통계로 보관합니다.'],
          ['문의', '답변 받을 이메일, 문의 내용, 첨부 이미지', '답변 또는 종결 후 90일, 답변하지 못한 문의는 접수 후 180일'],
          ['로그인 기록', '로그인한 기기별 인증 정보(암호화하여 저장)', '마지막 사용 후 7일'],
          ['자동 수집', '접속 IP, 브라우저·기기 정보, 접속 기록, 쿠키', '서버 로그는 30일, 외부 도구는 4번 항목의 보유 기간'],
        ],
      },
      { type: 'paragraph', text: '회원 가입은 만 14세 이상만 할 수 있습니다.' },
    ],
  },
  {
    title: '3. 개인정보의 제3자 제공',
    blocks: [
      {
        type: 'paragraph',
        text: '키오스쿨은 1번의 목적 범위에서만 개인정보를 처리하며, 아래의 경우와 법령에 특별한 규정이 있는 경우 외에는 제3자에게 제공하지 않습니다.',
      },
      {
        type: 'table',
        headers: ['제공받는 자', '항목', '목적', '보유 기간'],
        rows: [
          ['손님이 주문한 주점의 운영진', '입금자명, 테이블 번호, 주문 내역', '입금 확인과 주문 처리', '입금자명은 주문 후 90일'],
          ['주점에 주문하는 손님', '주점의 은행, 계좌번호, 예금주명', '송금 안내', '주점이 계좌를 삭제할 때까지'],
        ],
      },
    ],
  },
  {
    title: '4. 개인정보 처리 위탁과 국외 이전',
    blocks: [
      { type: 'paragraph', text: '키오스쿨은 서비스 운영을 위해 다음 업체에 개인정보 처리를 맡깁니다.' },
      {
        type: 'table',
        headers: ['수탁자', '맡기는 업무'],
        rows: [
          ['Oracle Cloud Infrastructure (국내 리전)', '서버와 데이터베이스 운영'],
          ['Amazon Web Services, Inc. (서울 리전)', '이미지·첨부파일 저장, 데이터베이스 백업 보관, 웹사이트 배포'],
          ['주식회사 코리아포트원', '계좌 예금주 확인'],
        ],
      },
      {
        type: 'paragraph',
        text: '다음 업체에는 개인정보가 국외로 이전됩니다. 이전은 서비스를 이용할 때 네트워크를 통해 이루어집니다.',
      },
      {
        type: 'table',
        headers: ['이전받는 자 (연락처)', '국가', '이전 항목', '목적', '보유 기간'],
        rows: [
          [
            'Google LLC (support.google.com/policies/contact/general_privacy_form)',
            '미국',
            '방문한 페이지, 브라우저·기기 정보, 쿠키 식별자, 서버 로그(접속 IP, 요청 경로)',
            '이용 통계 분석(Google Analytics), 서버 로그 보관',
            '이용 통계는 최대 14개월, 서버 로그는 30일',
          ],
          [
            'Functional Software, Inc. (Sentry, compliance@sentry.io)',
            '미국',
            '오류 정보, 접속 IP, 주점 운영진의 회원 번호·이메일, 일부 이용 화면 기록(글자와 입력값은 가려서 기록)',
            '오류 추적',
            '최대 90일',
          ],
          [
            'Plus Five Five, Inc. (Resend, support@resend.com)',
            '미국',
            '이메일 주소, 메일 내용',
            '인증 코드, 비밀번호 재설정, 문의 답변 메일 발송',
            'Resend의 발송 기록 보관 기간',
          ],
          [
            'Discord Inc. (privacy@discord.com)',
            '미국',
            '가입한 운영진의 아이디·이름·이메일, 주점 이름과 만든 사람 이름, 문의 제목, 안내 팝업 응답과 응답한 운영진의 아이디',
            '운영 알림',
            '운영 알림 채널에서 삭제할 때까지',
          ],
          ['Cloudflare, Inc. (privacyquestions@cloudflare.com)', '미국', '접속 IP, 브라우저 정보', '문의 폼 자동 등록 방지', 'Cloudflare의 보관 기간'],
        ],
      },
      {
        type: 'paragraph',
        text: '이용 통계 수집은 브라우저에서 쿠키를 차단해 거부할 수 있습니다. 오류 추적, 메일 발송, 운영 알림, 자동 등록 방지는 서비스 제공에 필요하므로 거부하면 회원 가입이나 문의 접수를 할 수 없습니다.',
      },
    ],
  },
  {
    title: '5. 개인정보의 파기',
    blocks: [
      {
        type: 'list',
        items: [
          '보유 기간이 지나거나 처리 목적을 이루면 지체 없이 파기합니다.',
          '전자 파일은 복구할 수 없는 방법으로 삭제합니다. 손님 입금자명은 주문 기록을 매출 통계로 남기기 위해 이름만 가립니다.',
          '장애 복구를 위해 데이터베이스 전체를 매시간 백업해 14일, 매월 백업해 1년 동안 보관한 뒤 삭제합니다. 그래서 위 기간이 지나 파기한 정보도 백업에는 이 기간만큼 남을 수 있습니다. 백업은 장애 복구 외의 목적으로 쓰지 않습니다.',
        ],
      },
    ],
  },
  {
    title: '6. 정보주체의 권리와 행사 방법',
    blocks: [
      {
        type: 'list',
        items: [
          '이용자는 언제든지 개인정보의 열람, 정정, 삭제, 처리 정지를 요구할 수 있습니다.',
          "주점 운영진은 '내 정보' 화면에서 계좌 정보를 바꾸거나 삭제할 수 있습니다. 회원 탈퇴를 포함한 그 밖의 요청은 문의하기나 아래 보호책임자 이메일로 보내 주세요.",
          '손님은 주문한 주점 이름, 주문 시각, 입금자명을 함께 적어 문의해 주시면 확인한 뒤 처리합니다.',
          '요청을 받으면 10일 안에 처리 결과를 알려 드립니다.',
        ],
      },
    ],
  },
  {
    title: '7. 개인정보의 안전성 확보 조치',
    blocks: [
      {
        type: 'list',
        items: [
          '비밀번호와 로그인 인증 정보는 원래 값으로 되돌릴 수 없는 방식으로 저장합니다.',
          '사이트와 서버 사이의 통신은 HTTPS로 암호화합니다.',
          '개인정보를 볼 수 있는 관리 권한을 최소한의 인원에게만 줍니다.',
          '데이터베이스 백업은 접근이 제한된 저장소에 보관합니다.',
        ],
      },
    ],
  },
  {
    title: '8. 쿠키의 사용',
    blocks: [
      {
        type: 'list',
        items: [
          '키오스쿨은 로그인 상태를 유지하는 쿠키(필수)와 이용 통계를 위한 Google Analytics 쿠키를 사용합니다.',
          '브라우저 설정에서 쿠키 저장을 거부할 수 있습니다. 로그인 쿠키를 거부하면 주점 관리 기능을 쓸 수 없습니다.',
        ],
      },
    ],
  },
  {
    title: '9. 개인정보 보호책임자',
    blocks: [
      { type: 'paragraph', text: '개인정보 관련 문의, 불만, 피해 구제는 아래 보호책임자에게 연락해 주세요.' },
      {
        type: 'table',
        headers: ['성명', '이메일'],
        rows: [[PRIVACY_OFFICER.name, PRIVACY_OFFICER.email]],
      },
    ],
  },
  {
    title: '10. 권익침해 구제 방법',
    blocks: [
      { type: 'paragraph', text: '개인정보 침해에 대한 신고나 상담이 필요하면 아래 기관에 문의할 수 있습니다.' },
      {
        type: 'list',
        items: [
          '개인정보분쟁조정위원회: 1833-6972 (www.kopico.go.kr)',
          '개인정보침해신고센터: 118 (privacy.kisa.or.kr)',
          '대검찰청: 1301 (www.spo.go.kr)',
          '경찰청: 182 (ecrm.police.go.kr)',
        ],
      },
    ],
  },
  {
    title: '11. 개인정보처리방침의 변경',
    blocks: [
      {
        type: 'paragraph',
        text: `이 개인정보처리방침은 ${PRIVACY_POLICY_EFFECTIVE_DATE}부터 시행합니다. 내용이 바뀌면 시행 7일 전부터 이 페이지에 알립니다.`,
      },
    ],
  },
];
